import {axiosConfigNew as axios} from "../../../utils/axios";

export const apiGetLibrary = (body: any) => axios.get(`/sdot/subject`, {
  params: body
})

export const apiGetLibraryCurrent = (body: any) => axios.get(`/sdot/${body.type}`, {
  params: body.params
})
